import { ADMIN_USER_DETAILS_SUCCESS, ADMIN_USER_DETAILS_FAILURE, ADMIN_USER_DETAILS_RESET } from "../actions/AdminActions";

const initialState = {
    fetched: false,
    user: null,
    error: null
}

export default function adminUserDetailsReducer(state = initialState, action) {

    switch (action.type) {
        case ADMIN_USER_DETAILS_RESET:
            return {
                fetched: false,
                user: null,
                error: null
            }
        case ADMIN_USER_DETAILS_SUCCESS:
            return {
                fetched: true,
                user: action.payload.user,
                error: null
            };
        case ADMIN_USER_DETAILS_FAILURE:
            return {
                fetched: true,
                user: null,
                error: action.payload.error
            }
        default:
            return state;
    }
}